// eslint-disable-next-line import/no-cycle
import BlogDefaultThumbnail from '../assets/default/default-image-blog.png';
import GreenDefaultThumbnail from '../assets/default/default-image-green.png';
import HomeDefaultThumbnail from '../assets/default/default-image-marketplace-home.png';
import MarketPlaceDefaultThumbnail from '../assets/default/default-image-marketplace.png';

/* ROUTERS  */
export const ROUTES = {
  MAIN: '/',
  LOGOUT: '/logout',
  SIGNUP: '/signup',
  LOGIN: '/login',
  FORGET_PASSWORD: '/forgot-password',
  RESET: '/reset-password',
  VERIFY: '/verify',
  AUTHENTICATION: '/authentication',
  MOVIES: '/movies',
  MOVIE_DETAIL: '/movies/:id',
  ADD_MOVIES: '/movies/add',
  EDIT_MOVIES: '/movies/edit/:id',
  TABLE: '/tables',
  SAMPLE: '/sample',
  PROFILE: '/profile',
  ALLCOMPONENT: '/allComponents',
  SEARCH_AI: '/search-ai',
  GREEN_HUB: '/green-hub',
};

/*  Modules */
export const MODULES = {
  DASHBOARD: 'Dashboard',
  MOVIES: 'Movies',
  SAMPLE: 'Sample',
};

/* Authentication */
export const TOKEN = 'TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER = 'USER';

export const ROLES = {
  SUPER_ADMIN: 'Super admin',
  ADMIN: 'Admin',
};

export const ROLE_KEYS = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
};

/* Date and time */
export const defaultDateFormat = 'MM/DD/YYYY';

export const REGEX = {
  NAME: /^[a-z ,.'-]+$/i,
  ZIPCODE: /^[0-9]{5,6}$/,
  CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  WEB_URL: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  PASSWORD: /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
  PHONE: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
  EMAIL: /^(([^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+(\.[^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  AMOUNT: /^\d+$|^\d+\.\d*$/,
  OPTIONALNEGATIVEAMOUNT: /^[-]?\d+$|^[-]?\d+\.\d*$/,
  NUMBER: /^\d+$/,
  COUNTRY_CODE_PHONE: /^[0-9]{7,12}$/,
};

export const LIMIT = 10;
export const SCROLL_PERCENT = 0.85;

export const MOVIES_SORT_FIELD = [
  { name: 'Created At', value: 'createdAt' },
  { name: 'Updated At', value: 'updatedAt' },
  { name: 'Release Date', value: 'releaseDate' },
  { name: 'Popularity', value: 'popularity' },
  { name: 'Rate', value: 'voteAverage' },
];
export const ORDER = [
  { name: 'Ascending', value: 'ASC' },
  { name: 'Descending', value: 'DESC' },
];

export const CREDIT_TYPE = [
  { name: 'Cast', value: 'CAST' },
  { name: 'Crew', value: 'CREW' },
];

export const GENDER = [
  { name: 'Female', value: 'FEMALE' },
  { name: 'Male', value: 'MALE' },
  { name: 'Other', value: 'OTHER' },
];
export const ERROR_PAGE_TITLE = 'Oops! An error occurred!';
export const ERROR_PAGE_SUBTITLE =
  'Something is broken. Please let us know what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.';

export const GUTTER_VARIATIONS = { xs: 16, sm: 16, md: 24, lg: 32 };

export const MOVIE_STATUS = {
  PENDING: 'Pending',
  RELEASED: 'Released',
};

export const BREAKPOINTS = {
  mobile: 550,
  tablet: 767,
  desktop: 1000,
  hd: 1200,
};

/* Message */
export const SOMETHING_WENT_WRONG = 'Something went wrong!';
export const NO_REFERENCES_FOUND = 'No references found';

/* Toast Type */
export const TOAST_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
};

/* Default Blog List */
export const DEFAULT_BLOG_LIST = [
  {
    Id: 1,
    'Reference Text':
      'complaints Complaints\n\nOur mission is to help you have a better life with your money and we’d like to think we get this right as often as we can.But things do go wrong every now and again.',
    Url: 'https://www.tandem.co.uk/complaints',
    Page: 'Complaints',
    category: 'complaints',
  },
  {
    Id: 2,
    'Reference Text':
      'careers Careers\n\nWe are building a greener digital bank and believe everyone deserves a better life with money.',
    Url: 'https://www.tandem.co.uk/careers',
    Page: 'Careers',
    category: 'careers',
  },
  {
    Id: 3,
    'Reference Text':
      'dealer-centre Motor Finance\n\nDealer Centre\n\nPartner with us and give your customers a smarter way to finance their next used car, with Tandem Motor Finance.',
    Url: 'https://www.tandem.co.uk/partners/dealer-centre',
    Page: 'Dealer Centre',
    category: 'partners',
  },
  {
    Id: 4,
    'Reference Text':
      'privacy-policy Privacy Policy\n\nTandem is committed to protecting your privacy.',
    Url: 'https://www.tandem.co.uk/privacy-policy',
    Page: 'Privacy Policy',
    category: 'privacy-policy',
  },
  {
    Id: 5,
    'Reference Text':
      'bespoke-mortgages Bespoke mortgages\n\nOur expert knowledge married with unrivalled customer service makes our mortgage process seamless and stress free.',
    Url: 'https://www.tandem.co.uk/partners/bespoke-mortgages',
    Page: 'Bespoke Mortgages',
    category: 'partners',
  },
  {
    Id: 6,
    'Reference Text':
      'Alex Mollart, Deputy Chief Executive of Tandem Bank, said: “We’re really proud to launch our financial education programme in Lancashire, helping young people engage with and understand good financial management. This is an essential life skill; and our ambition is to ensure the next generation has the financial knowledge they need to make informed decisions about how best to manage their money. “The programme has been designed to make this fun, inclusive and uncomplicated.',
    Url: 'https://www.tandem.co.uk/newsroom/financial-education-on-the-road',
    Page: 'Financial Education On The Road',
    category: 'newsroom',
  },
  {
    Id: 7,
    'Reference Text': 'savings Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/contact/savings',
    Page: 'Savings',
    category: 'contact',
  },
  {
    Id: 8,
    'Reference Text': 'savings Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/faq/savings',
    Page: 'Savings',
    category: 'faq',
  },
  {
    Id: 9,
    'Reference Text': 'iasa Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/save/iasa',
    Page: 'Iasa',
    category: 'save',
  },
  {
    Id: 10,
    'Reference Text':
      'new-2nd-charge-mortgage-feature-offers-rate-reductions-based-on-epc-rating Got a question about a savings account?',
    Url:
      'https://www.tandem.co.uk/newsroom/new-2nd-charge-mortgage-feature-offers-rate-reductions-based-on-epc-rating',
    Page:
      'New 2Nd Charge Mortgage Feature Offers Rate Reductions Based On Epc Rating',
    category: 'newsroom',
  },
  {
    Id: 11,
    'Reference Text': 'fixed-saver Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/save/fixed-saver',
    Page: 'Fixed Saver',
    category: 'save',
  },
  {
    Id: 12,
    'Reference Text': 'save Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/save',
    Page: 'Save',
    category: 'save',
  },
  {
    Id: 13,
    'Reference Text':
      'Return to Newsroom\n\nBanking\n\nJune 1, 2023\n\nTandem Bank reports transformational year in 2022\n\nTandem, the UK’s greener bank, delivers full year profitability for first time in the bank’s history after 12 months of strong growth. ‍Blackpool, 01 June 2023\n\nTandem Bank is further cementing its position as one of the nation’s go-to banks for those looking to save, borrow and spend a little bit greener, as it reports its business performance for 2022. With a transformational year, the bank has surpassed a number of financial milestones:\n\nUnderlying operating profit of £4.5m – breaking into underlying profitability for the first time in bank’s history\n\nRetail deposits increased from £771m to £1.75bn (uplift of 128%)\n\n£350m of second charge mortgages originated (FY21: nil)\n\nTandem launched bespoke mortgage product in February 2022\n\n£238m of green home improvement lending (FY21: £136m), taking the book to £272m (FY21: £150m) – representing 68% of lending at YE\n\nMotor Finance re-launched, totalling £11m (FY21: £0.3m) taking the book size to £18.3m (FY21: £9.3m)\n\nBut with redefining its mission to make it easier for more people to choose a greener lifestyle, the bank also had successes in maximising potential in supporting the UK’s transition to net zero and the shift to a carbon neutral economy:\n\nNew single Tandem brand with clear business purpose to support green credentials – Banking for a Greener Future\n\nThe launch of the UK’s first greener Marketplace\n\nCreation and roll-out of new impact strategy and ESG framework, focused across product, planet and people\n\n68% of all loans now supporting green lending (23% by value)\n\nOver 35k trees planted and 20k volunteering hours by employees across Tandem’s five sites\n\nSignatory of the 2025 Fintech Pledge and proud member of the Green Finance Institute’s Coalition for the Energy Efficiency of Buildings\n\nActivity has and performance has also been underpinned by enhancements in the bank’s product and proposition offerings, including:\n\nLaunch of first specialised mortgage product\n\nLaunch of new EPC discount mortgage feature\n\nDelivery of new savings journey for customers, including an award award-winning savings app and online journey\n\nPartnership with Raisin savings platform\n\nLaunch of its market-leading Top Up rate for savers\n\nBut underpinning Tandem’s future is an investment and enhancement of its digital, data and technology capabilities.',
    Url:
      'https://www.tandem.co.uk/newsroom/banking-for-a-greener-future-tandem-bank-reports-transformational-year-in-2022',
    Page:
      'Banking For A Greener Future Tandem Bank Reports Transformational Year In 2022',
    category: 'newsroom',
  },
  {
    Id: 14,
    'Reference Text': 'support Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/support',
    Page: 'Support',
    category: 'support',
  },
  {
    Id: 15,
    'Reference Text': 'general Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/faq/general',
    Page: 'General',
    category: 'faq',
  },
  {
    Id: 16,
    'Reference Text': 'home Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/',
    Page: 'Home',
  },
  {
    Id: 17,
    'Reference Text':
      'news-and-opinion News and Opinion - British Ecological Society\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nHome\n\n\n\n\n\n\r\n\t\t\t\t\tMENU\r\n\t\t\t\t\n\n\n\n\t\t\tDONATE - ECOLOGY THE NEXT GENERATION\t\t\n\n\n\n\n\n\n\nHome\n\n\nPolicy\nOpen\n\nOur Position\n\n\nThe future of ecological research in the UK\nOpen\n\nLaunch event\n\n\nExpert panel\n\n\nAbout the project\n\n\nRead the reports\n\n\nNews release\n\n\n\n\nReports & Publications\nOpen\n\nConsultation & Inquiry Responses\n\n\nEvent Reports\n\n\nPolicy Guides\n\n\nPolicy Briefs\n\n\nLegislative Scans\n\n\n\n\nProtected Areas\nOpen\n\nIntroducing protected areas\n\n\nRead the report\n\n\nExecutive summary\n\n\nConclusion\n\n\nHear from the authors\n\n\nNews release\n\n\nLaunch event\n\n\n\n\nNature-based solutions\nOpen\n\nWhat are nature-based solutions?',
    Url: 'https://www.britishecologicalsociety.org/news-and-opinion/',
    Page: 'News And Opinion',
  },
  {
    Id: 18,
    'Reference Text': 'blog Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/blog',
    Page: 'Blog',
    category: 'blog',
  },
  {
    Id: 19,
    'Reference Text': 'about Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/about',
    Page: 'About',
    category: 'about',
  },
  {
    Id: 20,
    'Reference Text': 'marketplace Got a question about a savings account?',
    Url: 'https://www.tandem.co.uk/marketplace',
    Page: 'Marketplace',
    category: 'marketplace',
  },
];

export function debounce(func, delay) {
  let timerId;

  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      func?.apply(this, args);
    }, delay);
  };
}

export const getUniqueValueFromArray = (array, key) => {
  const uniqueValues = [];
  const arrayList = [];
  array?.forEach((obj) => {
    const value = obj?.[key];
    if (!uniqueValues?.includes(value)) {
      uniqueValues?.push(value);
      arrayList?.push(obj);
    }
  });

  return arrayList;
};

export const DEFAULT_IMAGES = [
  BlogDefaultThumbnail,
  MarketPlaceDefaultThumbnail,
  GreenDefaultThumbnail,
  HomeDefaultThumbnail,
];
